<!-- Fixme: The color picker dialog overflows the screen. Position has been temporarily set to bottom. -->
<nz-input-group [nzPrefix]="selectedColorPreviewTemplate"
                [nzSuffix]="triggerIconTemplate"
                [ngClass]="{'color-picker-icon-only': displayMode === 'icon-only', 'color-picker-compact-mode': displayMode === 'compact'}">
  <input #colorPickerInput
         class="color-picker-input"
         [id]="elementId"
         [(ngModel)]="value"
         [value]="value"
         [colorPicker]="value"
         [ngClass]="cssClass"
         [ngStyle]="cssStyle"
         [cpSaveClickOutside]="saveClickOutside || false"
         [cpOKButton]="okButtonVisible || true"
         [cpOKButtonText]="okButtonText || 'SHARED.SAVE' | translate"
         [cpOKButtonClass]="okButtonClass || 'btn btn-primary btn-xs'"
         [cpCancelButton]="cancelButtonVisible || true"
         [cpCancelButtonText]="cancelButtonText || 'SHARED.CANCEL' | translate"
         [cpCancelButtonClass]="cancelButtonClass || 'ant-btn btn-xs'"
         [mask]="maskedInput()"
         [patterns]="colorPickerPatterns"
         [dropSpecialCharacters]="false"
         [cpPosition]="displayMode === 'icon-only' ? 'bottom-left' : 'bottom'"
         [cpPositionOffset]="displayMode === 'icon-only' ? '0%' : '0%'"
         [cpPositionRelativeToArrow]="false"
         (keypress)="onKeyPress($event)"
         (colorPickerSelect)="onBlur($event)" />
</nz-input-group>

<ng-template #selectedColorPreviewTemplate>
  <div *ngIf="value"
       class="selected-color-preview"
       [style.background]="value">
  </div>
</ng-template>

<ng-template #triggerIconTemplate>
  <div *ngIf="triggerIcon"
       class="color-picker-trigger-icon"
       (click)="openColorPickerDialog()">
    <rappider-icon [name]="triggerIcon.name"
                   [type]="triggerIcon.type"
                   [theme]="triggerIcon.theme"
                   [color]="triggerIcon.color"
                   [size]="triggerIcon.size"
                   [secondColor]="triggerIcon.secondColor"
                   [animation]="triggerIcon.animation"
                   [style]="triggerIcon.style"
                   [isClickable]="true">
    </rappider-icon>
  </div>
</ng-template>
